import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-sampling-plus': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8C389.4 8 496 118.1 496 256 496 403.1 377.5 504 247.6 504 113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zM248.4 52.7C130.2 52.7 44.7 150.6 44.7 256 44.7 365.8 135.9 458.8 248.4 458.8 351.6 458.8 451.2 377.7 451.2 256 451.3 142.2 361 52.7 248.4 52.7zM355.4 258.3C350.7 258.3 346.4 261.1 344.7 265.5L340.7 275 329.7 182.2C328 168.3 307.7 168.8 306.6 182.6L302.3 234 297.1 165.2C296 150.9 275 151 273.9 165.2L270.4 210.1 264.5 115.8C263.6 101.3 242.2 101.4 241.3 115.8L236.2 199.5 231.9 133.2C231 118.8 209.7 118.8 208.7 133.2L203.4 213.4 199.3 156.4C198.2 142.1 177.3 142.1 176.1 156.2L168.4 246 166.6 233.8C164.9 222.4 149.5 220.2 144.6 230.5L131.4 258.2H87.5V281.4H138.8C143.2 281.4 147.2 278.9 149.2 275L159.9 348.1C161.9 361.6 181.8 361.1 183 347.4L186.8 303.8 192.5 382.1C193.6 396.5 214.8 396.3 215.7 382L220.3 311.6 225.1 384.9C226 399.3 247.4 399.3 248.3 384.8L253.2 304.3 257.7 376.1C258.6 390.4 279.8 390.6 280.9 376.3L285.5 317.7 290.4 382.1C291.5 396.4 312.4 396.3 313.5 382.2L320.3 299.2 323 321.5C324.4 333.3 340.7 335.6 345.3 324.6L363.3 281.2H413.8V258L355.4 258.3zM277.4 263.5H255.5V285.4C255.5 289.5 252.2 292.9 248 292.9 243.9 292.9 240.5 289.6 240.5 285.4V263.5H218.6C214.5 263.5 211.1 260.2 211.1 256 211.1 251.9 214.5 248.5 218.6 248.5H240.5V226.6C240.5 222.5 243.9 219.1 248 219.1S255.5 222.4 255.5 226.6V248.5H277.4C281.5 248.5 284.9 251.8 284.9 256 284.9 260.1 281.5 263.5 277.4 263.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-sampling-plus.js
// module id = 2cnY
// module chunks = 144